import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PureSupplierRelationshipsSelectionSupplierFragmentDoc } from './PureSupplierRelationshipsSelectionSupplier.generated'
import { QuotesModalLineFragmentDoc } from './QuotesModalLine.generated'
import * as Types from './purchasePlus_graphql'

export const SupplierSelectorButtonLineFragmentDoc = gql`
  fragment SupplierSelectorButtonLine on RequisitionLine {
    id
    uuid
    product {
      id
    }
    taxPercentage
    quantity
    unitPrice
    supplier {
      ...PureSupplierRelationshipsSelectionSupplier
    }
    ...QuotesModalLine
  }
  ${PureSupplierRelationshipsSelectionSupplierFragmentDoc}
  ${QuotesModalLineFragmentDoc}
` as unknown as DocumentNode<Types.SupplierSelectorButtonLineFragment, unknown>
